var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:('page-' + this.$route.name).toLowerCase().replace(' ', '-')},[_c('vue-snotify'),_c('modals-container'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }